import { useNavigate } from "react-router-dom";
import NotesLayout from "./layouts/NotesLayout";
import Note from "../model/Note";
import NoteForm from "../components/NoteForm";

const NoteCreatePage = () => {
    const navigate = useNavigate();
 
    const onSaveNote = (note: Note) => {
        navigate(`/notes/${note.id}`)
    }
    
    return (
        <div className={"page-note"}>
            {/* <NotesLayout> */}
                <NoteForm onSave={onSaveNote}/>
            {/* </NotesLayout> */}
        </div>
    )
}

export default NoteCreatePage;